// ── Shared 15-minute slot options for network↔clinic scheduling ─────────────
//
// ONE source of truth for ALL FOUR proposal-time dropdowns (network propose
// + network reschedule, clinic suggest + clinic counter) so the two portals
// cannot drift. Product decision (2026-06): network-clinic scheduling
// matches WestStar-clinic booking — slots every 15 minutes, 15-minute
// duration, chosen from a dropdown instead of free-typed times.
//
// Values are the HH:MM wire format the backend expects; labels are 12-hour.
// 07:00 → 18:45 in 15-minute steps = 48 options.
export const SLOT_OPTIONS = (() => {
  const out = [];
  for (let h = 7; h <= 18; h++) {
    for (const m of [0, 15, 30, 45]) {
      const value = `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
      const h12 = h % 12 === 0 ? 12 : h % 12;
      const label = `${h12}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`;
      out.push({ value, label });
    }
  }
  return out;
})();
